import { useEffect, useRef, useState } from 'react';
import { modalStack } from './modalStack.mjs';

// Reference counter for nested modals — only restore overflow when last modal unmounts
let openModalCount = 0;

export default function Modal({ onClose, title, children, maxWidth = 'max-w-2xl' }) {
  // Render order determines which open modal handles Escape.
  const [order] = useState(() => modalStack.next());
  const closeRef = useRef(onClose);
  closeRef.current = onClose;

  useEffect(() => {
    modalStack.open(order);
    const handleEsc = (e) => { if (e.key === 'Escape' && modalStack.isTop(order)) closeRef.current(); };
    document.addEventListener('keydown', handleEsc);

    openModalCount++;
    if (openModalCount === 1) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEsc);
      modalStack.close(order);
      openModalCount--;
      if (openModalCount === 0) {
        document.body.style.overflow = '';
      }
    };
  }, [order]);

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Only a click on the backdrop itself closes, so dragging out of the panel does not. */}
      <div className="absolute inset-0 bg-black/50" onClick={onClose} />
      <div
        className={`relative bg-white dark:bg-slate-800 rounded-xl shadow-2xl ${maxWidth} w-full max-h-[90vh] overflow-y-auto p-6`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between mb-4">
          {title && <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h2>}
          <button onClick={onClose} className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors text-xl leading-none shrink-0" aria-label="Close">&times;</button>
        </div>
        {children}
      </div>
    </div>
  );
}
